/**
 * Frontend JavaScript für Parking Routes Block
 */

document.addEventListener('DOMContentLoaded', function () {
    const copyButtons = document.querySelectorAll('.route-copy-btn');

    copyButtons.forEach(button => {
        button.addEventListener('click', async function () {
            const address = this.dataset.address;
            const copyText = this.querySelector('.copy-text');
            const successText = this.querySelector('.copy-success');

            try {
                // Moderne Clipboard API
                await navigator.clipboard.writeText(address);

                // Visuelles Feedback
                copyText.style.display = 'none';
                successText.style.display = 'inline';
                button.classList.add('copied');

                // Nach 2 Sekunden zurücksetzen
                setTimeout(() => {
                    copyText.style.display = 'inline';
                    successText.style.display = 'none';
                    button.classList.remove('copied');
                }, 2000);

            } catch (err) {
                // Fallback für ältere Browser
                fallbackCopyToClipboard(address, button, copyText, successText);
            }
        });
    });

    // Fallback-Methode für ältere Browser
    function fallbackCopyToClipboard(text, button, copyText, successText) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();

        try {
            document.execCommand('copy');
            copyText.style.display = 'none';
            successText.style.display = 'inline';
            button.classList.add('copied');

            setTimeout(() => {
                copyText.style.display = 'inline';
                successText.style.display = 'none';
                button.classList.remove('copied');
            }, 2000);
        } catch (err) {
            console.error('Kopieren fehlgeschlagen:', err);
        }

        document.body.removeChild(textArea);
    }
});